import type { FC } from 'react'
import React, { memo } from 'react'
import { useFormContext } from 'react-hook-form'
import { CommonLink } from '@frontend/pole-ui/lib/components/CommonLink'
import type { IConsultingFormValues } from '@/components/composed/ConsultingForm/types'
import { Checkbox } from '@/components/ui/ReactHookFormFields'
import { useData } from '@/logic/data'
import { getLegalDocumentUrl } from '@/logic/legalDocuments/helpers'
import type { TLegalDocuments } from '@/types/legalDocuments'
import { ELegalDocumentType } from '@/types/legalDocuments'
import { formatLocalizedString } from '@/utils/formatUtils'
import { useDeviceType } from '@/utils/hooks/useDeviceType'
import { messages } from './messages'
import type { TConsultingFormAgreementComponentProps } from './types'
import './styles.scss'

const ConsultingFormAgreementComponent: FC<TConsultingFormAgreementComponentProps> = () => {
  const { data: legalDocuments = [] } = useData<TLegalDocuments>('legalDocuments')
  const { isMobile } = useDeviceType()
  const { control } = useFormContext<IConsultingFormValues>()

  return (
    <div className="consultingFormAgreement">
      <Checkbox
        labelTextClassName="consultingFormAgreement__labelText"
        control={control}
        id="agreement"
        name="agreement"
        isMobile={isMobile}
        rules={{ required: messages.required }}
        errorClassName="consultingFormAgreement__error"
      >
        <div>
          {formatLocalizedString(messages.text, {
            agreement: (
              <CommonLink
                url={getLegalDocumentUrl(legalDocuments, ELegalDocumentType.personalDataConsent)}
                shouldOpenInNewWindow
                className="underline underline_green color_green"
              >
                {messages.agreement}
              </CommonLink>
            ),
            policy: (
              <CommonLink
                url={getLegalDocumentUrl(legalDocuments, ELegalDocumentType.registrationPolicy)}
                shouldOpenInNewWindow
                className="underline underline_green color_green"
              >
                {messages.policy}
              </CommonLink>
            ),
          })}
        </div>
      </Checkbox>
    </div>
  )
}

export const ConsultingFormAgreement = memo(ConsultingFormAgreementComponent)
